import { QueryClient } from "@tanstack/react-query";
import { APP_CONFIG } from "@/lib/constants/app-config";
import { isApiError } from "./api-error";

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: APP_CONFIG.defaultQueryStaleTimeMs,
        gcTime: APP_CONFIG.defaultQueryGcTimeMs,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          // Don't retry hard auth / authorisation failures.
          if (isApiError(error)) {
            if (error.status === 401 || error.status === 403 || error.status === 423) {
              return false;
            }
            if (error.status === 404 || error.status === 409) return false;
          }
          return failureCount < 2;
        },
      },
      mutations: {
        // Mutations are operational/dangerous — surface failures immediately.
        retry: false,
      },
    },
  });
}
